<div class="modal">
  <div class="container model-container {{data.customClass}}">
    <div class="modal-header">
      <h2 class="modal-heading">{{data.title}}</h2>
      <img src="assets/icon/popup-close-icon.svg" (click)="closeDialog()" class="close-icon" width="32" height="32"
        alt="Close Icon">
    </div>
     <div id="modal-body-section" class="modal-body">
      <div class="modal-content">
          <inter-calling-price-table #payGo [inModal]="true" categoryId="pay-go" valueTitle="Price"></inter-calling-price-table>
      </div>
    </div>
  </div>
</div>